export const PAYMENT_CARD_TYPE_IDS = {
  AmericanExpress: 1, Visa: 2, MasterCard: 3, Discover: 4,
};

export const PAYMENT_METHOD_OPTION_IDS = {
  Card: 'card',
  Ach: 'ach',
};

// #genai ACH layout variants for AchPaymentInformation — Phase 1 = legacy billing screen;
// Phase 2 = Add-Bank page (Figma). Comparisons and props must use these, not string literals.
export const ACH_PAYMENT_VARIANTS = {
  Phase1: 'phase1',
  Phase2: 'phase2',
};

// #genai Phase 2 payment-methods list `actionError.kind` values — written by the billing reducer and
// read by SavedPaymentMethods banners. Kept next to PAYMENT_METHOD_OPTION_IDS so the vocabulary that
// ties the list mutations together lives in one place (no separate constants file).
export const PAYMENT_METHODS_ACTION_ERROR_KIND = {
  Default: 'default',
  Remove: 'remove',
  Blocked: 'blocked',
};

// #genai Server-authoritative ACH account-type codes (MYEV_UI_INTEGRATION_GUIDE).
export const ACH_ACCOUNT_TYPE_IDS = {
  Checking: 'C',
  Savings: 'S',
  CorporateChecking: 'X',
};

// #genai ACH account-type code for Corporate Checking ('X'). First / Last name remain mandatory
// on Phase 2 Add-Bank (same as other account types); Company is also mandatory.
export const ACH_CORPORATE_CHECKING_TYPE = ACH_ACCOUNT_TYPE_IDS.CorporateChecking;

// #genai Placeholder shown in the Routing Number input when an existing bank account is on file
// but the backend doesn't expose the routing number (PCI-protected).
export const ACH_SAVED_ROUTING_MASK = 'XXXXXX';

export const PAYMENT_CARD_TYPE_OPTION = [
  {
    id: PAYMENT_CARD_TYPE_IDS.AmericanExpress,
    description: 'American Express',
  },
  {
    id: PAYMENT_CARD_TYPE_IDS.Visa,
    description: 'Visa',
  },
  {
    id: PAYMENT_CARD_TYPE_IDS.MasterCard,
    description: 'MasterCard',
  },
  {
    id: PAYMENT_CARD_TYPE_IDS.Discover,
    description: 'Discover',
  },
];

export const PAYMENT_METHOD_OPTIONS = [
  {
    id: PAYMENT_METHOD_OPTION_IDS.Card,
    description: 'Card',
  },
  {
    id: PAYMENT_METHOD_OPTION_IDS.Ach,
    description: 'ACH',
  },
];

export const ACH_ACCOUNT_TYPE_OPTIONS = [
  {
    id: ACH_ACCOUNT_TYPE_IDS.Checking,
    description: 'Checking',
  },
  {
    id: ACH_ACCOUNT_TYPE_IDS.Savings,
    description: 'Savings',
  },
  {
    id: ACH_ACCOUNT_TYPE_IDS.CorporateChecking,
    description: 'Corporate Checking',
  },
];

// #genai Phase 2 dropdown labels and order per Figma 226:26363
export const PHASE2_ACH_ACCOUNT_TYPE_OPTIONS = [
  { id: ACH_ACCOUNT_TYPE_IDS.CorporateChecking, description: 'Corporate Checking' },
  { id: ACH_ACCOUNT_TYPE_IDS.Checking, description: 'Personal Checking' },
  { id: ACH_ACCOUNT_TYPE_IDS.Savings, description: 'Savings' },
];
